import { bufferToUrl } from '../helpers';
export default [
    'LogService',
    function (logService) {
        const log = logService.getLogger('AvatarEditor-C');
        return {
            restrict: 'EA',
            scope: {
                onChange: '=',
            },
            link(scope, element, attrs, controller) {
                const DRAGOVER_CSS_CLASS = 'is-dragover';
                const VIEWPORT_SIZE = 220;
                const editorArea = angular.element(element[0].querySelector('.avatar-editor'));
                const fileTrigger = angular.element(element[0].querySelector('.file-trigger'));
                const fileInput = angular.element(element[0].querySelector('input.file-input'));
                let croppieInstance = null;
                const initCroppie = () => {
                    if (croppieInstance === null) {
                        const croppieTarget = element[0].querySelector('.croppie-target');
                        croppieInstance = new Croppie(croppieTarget, {
                            viewport: {
                                type: 'square',
                                width: VIEWPORT_SIZE,
                                height: VIEWPORT_SIZE,
                            },
                            customClass: 'has-image',
                            showZoomer: true,
                            update: () => {
                                if (updateTimeout !== undefined) {
                                    clearTimeout(updateTimeout);
                                }
                                updateTimeout = self.setTimeout(async () => {
                                    const image = await croppieInstance.result({
                                        type: 'blob',
                                        size: { width: 512, height: 512 },
                                        circle: false,
                                        format: 'png',
                                    });
                                    const fileReader = new FileReader();
                                    fileReader.onload = function () {
                                        scope.onChange(fileReader.result);
                                    };
                                    fileReader.readAsArrayBuffer(image);
                                }, 500);
                            },
                        });
                    }
                    return croppieInstance;
                };
                function loading(show) {
                    if (show) {
                        editorArea.addClass('loading');
                    }
                    else {
                        editorArea.removeClass('loading');
                    }
                }
                let updateTimeout;
                function fetchFileContent(file) {
                    return new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.onload = function (ev) {
                            resolve(this.result);
                        };
                        reader.onerror = function (ev) {
                            reject(ev);
                        };
                        reader.onprogress = function (ev) {
                            if (ev.lengthComputable) {
                            }
                        };
                        reader.readAsArrayBuffer(file);
                    });
                }
                function uploadFiles(fileList) {
                    if (fileList.length < 1) {
                        return;
                    }
                    fetchFileContent(fileList[0]).then((data) => {
                        const image = bufferToUrl(data, 'image/jpeg', log);
                        setImage(image);
                    }).catch((ev) => {
                        log.error('Could not load file:', ev.message);
                    });
                }
                function onDrop(ev) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    onDragleave(ev);
                    uploadFiles(ev.dataTransfer.files);
                }
                function onDragover(ev) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    editorArea.addClass(DRAGOVER_CSS_CLASS);
                }
                function onDragleave(ev) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    editorArea.removeClass(DRAGOVER_CSS_CLASS);
                }
                function onFileTrigger(ev) {
                    ev.preventDefault();
                    ev.stopPropagation();
                    const input = element[0].querySelector('.file-input');
                    input.click();
                }
                function onFileUploaded() {
                    uploadFiles(this.files);
                }
                function setImage(imageBase64Url) {
                    const croppie = initCroppie();
                    loading(true);
                    const img = new Image();
                    img.addEventListener('load', async () => {
                        log.debug('Image loaded');
                        const w = img.naturalWidth;
                        const h = img.naturalHeight;
                        const size = Math.min(w, h);
                        const imageSize = [
                            (w - size) / 2,
                            (h - size) / 2,
                            size,
                            size,
                        ];
                        try {
                            await croppie.bind({
                                url: imageBase64Url,
                                points: imageSize,
                            });
                        }
                        catch (error) {
                            log.error('Could not bind avatar preview:', error);
                        }
                        loading(false);
                    });
                    img.addEventListener('error', function (e) {
                        log.error('Could not load image:', e);
                        loading(false);
                    });
                    img.src = imageBase64Url;
                }
                editorArea.on('dragover dragenter', onDragover);
                editorArea.on('dragleave dragend', onDragleave);
                editorArea.on('drop', onDrop);
                fileTrigger.on('click', onFileTrigger);
                fileInput.on('change', onFileUploaded);
            },
            template: `
                <div class="avatar-editor">
                    <div class="avatar-editor-drag croppie-target"></div>
                    <div class="avatar-editor-navigation" layout="column" layout-wrap layout-margin layout-align="center center">
                        <input class="file-input" type="file" style="visibility: hidden" multiple>
                          <md-button type="submit" class="file-trigger md-raised">
                            <span translate>messenger.UPLOAD_AVATAR</span>
                           </md-button>
                    </div>
                </div>
            `,
        };
    },
];
